import { realtimeDb } from '@/service/firebase';

export default {
  getFeatures({ commit }) {
    realtimeDb.ref('settings/features').on('value', snap => {
      commit('setFeatures', snap.val());
    });
  },
};
